module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-c40678d0!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-radio/index.vue
// module id = 542
// module chunks = 0 1